import { Link } from "react-router-dom";
import Photo from "../ui/Photo";
import { STAFF } from "../../data/salon";
import { faRating, toFa } from "../../lib/format";
import { useStagger } from "../../lib/motion";
import { SectionHead } from "../ui/Bits";

export default function Team() {
  const grid = useStagger({ step: 70 });

  return (
    <section className="section section--defer team">
      <div className="wrap wrap--wide">
        <SectionHead
          eyebrow="OUR TEAM"
          title="کار را <em>متخصصش</em> انجام می‌دهد"
          lede="شش نفر، هر کدام سال‌ها روی یک حوزه متمرکز."
          to="/staff"
          toLabel="پروفایل متخصصین"
        />

        <div className="team__grid" ref={grid}>
          {STAFF.map((p, i) => (
            <Link
              key={p.id}
              to="/staff"
              className={`tcard reveal${i % 3 === 1 ? " tcard--drop" : ""}`}
              data-stagger=""
            >
              <Photo src={p.photo} ratio="3 / 4" className="ph--hover" tint="soft" />

              <span className="tcard__body">
                <span className="tcard__name">{p.name}</span>
                <span className="tcard__role">{p.role}</span>
                <span className="tcard__meta">
                  <span>{toFa(p.experience)} سال</span>
                  <span className="tcard__sep" aria-hidden="true" />
                  <span>★ {faRating(p.rating)}</span>
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
